import axios from 'axios';

const httpProvider = {
    sendRequest(authToken, request) {
        request.headers = {
            'Content-Type': 'application/json',
            Accept: 'application/json',
            Authorization: `Bearer ${authToken}`,
            'Access-Control-Allow-Origin': '*',
            'Access-Control-Allow-Methods': 'GET, POST, PUT, DELETE',
            'Access-Control-Allow-Headers': 'Origin, Content-Type, X-Auth-Token',
            ...(request.headers || {})
        };

        return axios(request);
    }
};

export default httpProvider;
